import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="px-4 md:px-6 py-8 md:py-10">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-6 md:mb-8">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-2">影视分类</h2>
          <p className="text-sm md:text-base text-foreground-600">探索丰富的影视资源，发现你的专属精彩</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-100 rounded-xl cursor-pointer hover:bg-primary-50 transition-colors duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100/70 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="font-heading font-semibold text-foreground-900 text-sm md:text-base whitespace-nowrap">{cat.name}</span>
              <p className="text-xs text-foreground-500 text-center leading-relaxed hidden sm:block">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}